import { CHANNEL_LAYOUT_VALUES } from '@wix/wix-vod-constants/app-settings';
export const LAYOUTS_MAP = {
  [CHANNEL_LAYOUT_VALUES.CLASSIC]: 'classic',
  [CHANNEL_LAYOUT_VALUES.STRIP]: 'strip',
  [CHANNEL_LAYOUT_VALUES.COMPACT]: 'compact',
  [CHANNEL_LAYOUT_VALUES.SLIDER_SMALL]: 'small_slider',
  [CHANNEL_LAYOUT_VALUES.SLIDER_BIG]: 'big_slider',
  [CHANNEL_LAYOUT_VALUES.GRID]: 'grid'
};
//# sourceMappingURL=layouts-map.js.map